import { render, staticRenderFns } from "./ProductsCustomOrder.vue?vue&type=template&id=73eb3a21&scoped=true"
import script from "./ProductsCustomOrder.vue?vue&type=script&lang=ts"
export * from "./ProductsCustomOrder.vue?vue&type=script&lang=ts"
import style0 from "./ProductsCustomOrder.vue?vue&type=style&index=0&id=73eb3a21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eb3a21",
  null
  
)

export default component.exports